import { jsx } from "../../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.es.js";
import { DesktopDateTimePicker } from "./variants/desktop-date-time-picker.es.js";
import { MobileDateTimePicker } from "./variants/mobile-date-time-picker.es.js";
import { forwardRef } from "react";
const DateTimePicker = forwardRef(function DateTimePicker2({
  isMobile,
  ...rest
}, ref) {
  if (isMobile) {
    return /* @__PURE__ */ jsx(MobileDateTimePicker, { ...rest, ref });
  } else {
    return /* @__PURE__ */ jsx(DesktopDateTimePicker, { ...rest, ref });
  }
});
export {
  DateTimePicker
};
//# sourceMappingURL=date-time-picker.es.js.map
